import { SVGProps } from "react";

export function Eye(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1480_19699)">
        <path
          d="M8.00033 9.83317C8.73671 9.83317 9.33366 9.23622 9.33366 8.49984C9.33366 7.76346 8.73671 7.1665 8.00033 7.1665C7.26395 7.1665 6.66699 7.76346 6.66699 8.49984C6.66699 9.23622 7.26395 9.83317 8.00033 9.83317Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6663 8.50016C12.8883 11.6115 10.6663 13.1668 7.99967 13.1668C5.33301 13.1668 3.11101 11.6115 1.33301 8.50016C3.11101 5.38883 5.33301 3.8335 7.99967 3.8335C10.6663 3.8335 12.8883 5.38883 14.6663 8.50016Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1480_19699">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
